"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    createAppearance: function() {
        return createAppearance;
    },
    deleteAppearance: function() {
        return deleteAppearance;
    },
    generateAppearances: function() {
        return generateAppearances;
    },
    resetAppearances: function() {
        return resetAppearances;
    },
    selectSegmentWinner: function() {
        return selectSegmentWinner;
    },
    updateAppearance: function() {
        return updateAppearance;
    },
    updateManager: function() {
        return updateManager;
    }
});
const _types = /*#__PURE__*/ _interop_require_wildcard(require("./types/index.js"));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function createAppearance(payload) {
    return {
        type: _types.ADD_APPEARANCE,
        payload
    };
}
function updateAppearance(payload) {
    return {
        type: _types.UPDATE_APPEARANCE,
        payload
    };
}
function deleteAppearance(payload) {
    return {
        type: _types.DELETE_APPEARANCE,
        payload
    };
}
function resetAppearances() {
    return {
        type: _types.RESET_APPEARANCES
    };
}
function updateManager({ wrestlerId, segmentId }) {
    return {
        type: _types.UPDATE_MANAGER,
        payload: {
            wrestlerId,
            segmentId
        }
    };
}
function generateAppearances(payload) {
    return {
        type: _types.GENERATE_APPEARANCES,
        payload
    };
}
function selectSegmentWinner({ wrestlerId, segmentId }) {
    return {
        type: _types.SELECT_SEGMENT_WINNER,
        payload: {
            wrestlerId,
            segmentId
        }
    };
}
